import { render, staticRenderFns } from "./Memorandos.vue?vue&type=template&id=c52291c8&"
import script from "./Memorandos.vue?vue&type=script&lang=js&"
export * from "./Memorandos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports